module.exports = __webpack_public_path__ + "img/fastForward_choosed.37e18791.png";